import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../api/api";
import { useAuth } from "../context/AuthContext";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";
import "./QpscCups.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function QpscCupsDetail() {

  const { playerId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [cups, setCups] = useState(null);
  const [player, setPlayer] = useState(null);

  useEffect(() => {
    Promise.all([
      api.get(`/cups/${playerId}`),
      api.get("/users")
    ]).then(([cupsRes, usersRes]) => {
      setCups(cupsRes);
      const u = usersRes.find(x => x.id === playerId);
      setPlayer(u);
    });
  }, [playerId]);
  
  const seasonData = useMemo(() => {
    if (!cups?.appearancesBySeason) return null;

    const labels = Object.keys(cups.appearancesBySeason).sort();
    const values = labels.map(s => cups.appearancesBySeason[s]);

      const isSuperAdmin =
        Array.isArray(user?.contexts) &&
        user.contexts.some(
          c =>
            String(c.role).toLowerCase() === "superadmin" &&
            c.contextType === "CLUB" &&
            c.status === "ACTIVE"
        );

      if (!isSuperAdmin) {
        return <div style={{ padding: 40, color: "gold" }}>Unauthorized</div>;
      }

    return {
      labels,
      datasets: [
        {
          label: "Appearances",
          data: values,
          backgroundColor: "#ffd700"
        }
      ]
    };
  }, [cups]);

  if (!cups || !player) return <div style={{ padding: 30 }}>Loading...</div>;

  return (
    <div className="cups-scrollpage">

      <div style={{ padding: "10px 20px" }}>
        <button className="home-link-btn" onClick={() => navigate(-1)}>
          ⏪ Back
        </button>
      </div>

      <h2 className="cups-title">
        {player.firstName} {player.lastName}
      </h2>

      <div className="cups-detail-card">

        <div className="cups-detail-main">
          <div><strong>DOB:</strong> {player.dob || "—"}</div>
          <div><strong>Total Caps:</strong> {cups.totalAppearances}</div>
          <div><strong>Goals:</strong> {cups.totalGoals}</div>
          <div><strong>Minutes:</strong> {cups.totalMinutes}</div>
          <div><strong>Yellow Cards:</strong> {cups.totalYellowCards}</div>
          <div><strong>Red Cards:</strong> {cups.totalRedCards}</div>
          <div><strong>First Game:</strong> {cups.firstGame}</div>
          <div><strong>Last Game:</strong> {cups.lastGame}</div>
        </div>

        <hr />

        <h3 style={{ color: "#ffd700" }}>Appearances by Season</h3>

        {seasonData && (
          <Bar
            data={seasonData}
            options={{
              responsive: true,
              plugins: {
                legend: { display: false }
              }
            }}
          />
        )}

        <hr />

        <h3 style={{ color: "#ffd700" }}>Appearances by Team</h3>

        <div className="cups-team-breakdown">
          {Object.entries(cups.appearancesByTeam || {}).map(([team, val]) => (
            <div key={team}>
              {team} → {val}
            </div>
          ))}
        </div>

        <hr />

        <h3 style={{ color: "#ffd700" }}>Timeline</h3>

        <div className="cups-timeline">
          {Object.entries(cups.appearancesBySeason || {})
            .sort(([a], [b]) => a.localeCompare(b))
            .map(([season, val]) => (
              <div key={season}>
                {season} – {val} Caps
              </div>
            ))}
        </div>

      </div>
    </div>
  );
}